import React from "react";
import { inject } from "mobx-react";
import { Cascader } from "antd";

import { $const, $util } from "../../../helper";

@inject("commonStore", "languageStore")
class CascaderSelect extends React.Component {
  getValueAndLabel = data => {
    if (!data) return null;
    return { value: data.value, label: data.label };
  };

  handleChange = (value, selectedOptions) => {
    const onChange = this.props.onChange;
    if (!onChange || !value || !selectedOptions) return;
    if (value.length === 0 && selectedOptions.length === 0) {
      onChange(null);
      return;
    }
    const formatData = {
      country: this.getValueAndLabel(selectedOptions[0]),
      province: this.getValueAndLabel(selectedOptions[1]),
      city: this.getValueAndLabel(selectedOptions[2])
    };
    onChange(Object.fromEntries(Object.entries(formatData).filter(item => !!item[1])));
  };

  getValueByLabel = (labelData, options) => {
    let addedOptions = [];
    for (let item of options) {
      const { value, label, children } = item;
      !!children && (addedOptions = addedOptions.concat(children));
      if (label === labelData || label === `${labelData}市` || label === `${labelData}省`) {
        return value;
      }
    }
    if (addedOptions.length > 0) {
      return this.getValueByLabel(labelData, addedOptions);
    }
    return null;
  };

  formatValue = (data, options) => {
    if (!data) return "";
    if (data.value && data.value !== "null") {
      return data.value;
    }
    return this.getValueByLabel(data.label, options);
  };

  getValue = (value, options) => {
    if (!value) return null;
    const { country, province, city } = value;
    return [
      this.formatValue(country, options),
      this.formatValue(province, options),
      this.formatValue(city, options)
    ];
  };

  render() {
    const lang = this.props.languageStore.lang;
    const areaData = $util.getLevelCity(this.props.commonStore.pca);
    // 国家
    let options = $const.COUNTRIES[lang];
    if (lang === "zh") {
      options[0].children = areaData;
    }

    const value = this.getValue(this.props.value, options);

    return (
      <Cascader
        options={options}
        onChange={this.handleChange}
        value={value}
        placeholder={this.props.placeholder}
      />
    );
  }
}

export default CascaderSelect;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/cascaderSelect.js